import React from 'react'
import axios from 'axios';
import { CURRENT_API_URL } from "../../../Utils/Constants";
import notify from '../../../Notifications/ToastifyActions';

function AssetStatusChangeService(token,data) {
    return axios.post(`${CURRENT_API_URL}/contentmanagement/assetStatusChange`,data,{
        headers: {
            'Authorization': token,
        }
    }).then(res => {
        console.log(res.data)
        // notify.NotifySuccess("Asset Status Changed successfully.");
        return res.data;        
    }).catch(error => {
        console.log(error);
        notify.NotifyError("An error occurred while changing Asset Status, please try again later.");
        return false;
    });
}

export default AssetStatusChangeService;